import { render } from "./GameAdminPage.vue?vue&type=template&id=17723aa0"
import script from "./GameAdminPage.vue?vue&type=script&lang=js"
export * from "./GameAdminPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__